import {
  IAffiliateCtaFields,
  IRegistrationEntrypointFields
} from '@/types/contentful';
import type { Asset } from 'contentful';
import type { InputHTMLAttributes } from 'react';

import { ButtonColorTokenProp } from '../../theme/tokens/button-color';
import { CFColorTokenProp } from '../../theme/tokens/contentful-color';

export type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  handleOnChange?: (val: string) => void;
  'aria-invalid'?: boolean;
  'aria-describedby'?: string;
};

export const DEFAULT_LABEL = 'Enter mobile number';
export const DEFAULT_PLACEHOLDER = '(000) 000-0000';
export const DEFAULT_BUTTON_TEXT = 'Get Started';

export const DEFAULT_EMAIL_LABEL = 'Enter email address';
export const DEFAULT_EMAIL_CTA_LABEL = 'Enter email address through CTA';
export const DEFAULT_EMAIL_BUTTON_TEXT = 'Notify Me';
export const VALID_EMAIL =
  'We will let you know when the app is up and running';
export const DEFAULT_EMAIL_WIDGET_BUTTON_TEXT = 'Submit';

export const SUBMITTED_TEXT = 'Submitted!';
export const THANKS_TEXT_WITH_SPACING =
  '\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0Thank you!';
export const THANKS_TEXT = 'Thank you!';

export enum ctaWidgetEnum {
  GET_STARTED = 'Get Started Button',
  GET_STARTED_NO_PHONE = 'Get Started - No Phone',
  MOBILE_PHONE_NUMBER = 'Button Inside Phone Number',
  MOBILE_PHONE_NUMBER_DROPSHADOW = 'Button Inside Phone Number - With Dropshadow',
  EMAIL = 'Email',
  STANDARD = 'Standard Button',
  ROLE_SELECT_WEBREG = 'Role Select Button - Webreg',
  GL4C_AUTH = 'GL4C Auth',
  GL4C_INLINE_AUTH = 'GL4C Inline Auth',
  DUAL_CTA_BUTTON = 'Dual-CTA Button',
  SMS_REG = 'Button Inside Phone Number SMS Reg',
  LOADER_STICKY_BUTTON = 'Updated Sticky Button'
}

export interface RegistrationEntrypoint
  extends Partial<
    Omit<
      IRegistrationEntrypointFields,
      | 'designType'
      | 'buttonColor'
      | 'buttonHoverColor'
      | 'buttonText'
      | 'returningUserButtonText'
    >
  > {
  sysId?: string;
  designType?: ctaWidgetEnum | IRegistrationEntrypointFields['designType'];
  buttonText?: JSX.Element | string;
  returningUserButtonText?: string;
  buttonColor?: ButtonColorTokenProp | CFColorTokenProp;
  buttonHoverColor?: ButtonColorTokenProp | CFColorTokenProp;
  buttonContent?: JSX.Element | string;
  cfButtonColor?: CFColorTokenProp;
  cfButtonHoverColor?: CFColorTokenProp;
  buttonVariant?: 'primary' | 'secondary' | 'sign-up';
  secondaryButtonText?: string;
  secondaryCfButtonColor?: CFColorTokenProp;
  secondaryCfButtonHoverColor?: CFColorTokenProp;
  // Parity with Button content type
  forwardedButtonParams?: string;
  icon?: Asset;
}

export type PartialCtaProps = RegistrationEntrypoint &
  Partial<IAffiliateCtaFields> &
  Partial<SharedProps>;

export interface SharedProps {
  id?: string;
  className?: string;
  submitted?: boolean;
  label?: string;
  placeholder?: string;
  errorMessage?: string | null;
  errorPosition?: 'top' | 'bottom';
  showErrorBanner?: boolean;
  sendConsentEvent?: boolean;
  fullWidth?: boolean;
}

export interface WidgetProps extends RegistrationEntrypoint {
  inputProps?: InputProps;
  isScrolled?: boolean;
  setErrorMessage?: (msg: string | null | undefined) => void;
  isReturning?: boolean;
  responsive?: boolean;
}
